"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var transition_1 = require("../transition");
var config_context_1 = require("../_util/config-context");
exports.FormControl = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var status = _a.status, children = _a.children, message = _a.message, extra = _a.extra, alignLabelTop = _a.alignLabelTop, _c = _a.showStatusIcon, showStatusIcon = _c === void 0 ? true : _c, className = _a.className, props = (0, tslib_1.__rest)(_a, ["status", "children", "message", "extra", "alignLabelTop", "showStatusIcon", "className"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var controlClassName = (0, classnames_1.default)(classPrefix + "-form__controls", (_b = {},
        _b[classPrefix + "-form__controls--text"] = alignLabelTop,
        _b["is-" + status] = status,
        _b), className);
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({ ref: ref, className: controlClassName }, props),
        children,
        react_1.default.createElement(transition_1.SlideTransition, { in: Boolean(status), from: [-10, 0] }, showStatusIcon ? (react_1.default.createElement("b", { className: classPrefix + "-icon " + classPrefix + "-icon-valid" })) : (react_1.default.createElement("b", null))),
        Boolean(message) && (react_1.default.createElement("div", { className: classPrefix + "-form__help-text" }, message)),
        Boolean(extra) && (react_1.default.createElement("div", { className: (0, classnames_1.default)(classPrefix + "-form__help-extra", classPrefix + "-form__help-text", classPrefix + "-text-label") }, extra))));
});
exports.FormControl.displayName = 'FormControl';
